<template>
  <div class="auth" id="auth" name="auth">
    <div class="top">
      <NavTop activeIndex="3"></NavTop>
    </div>
    <div class="content-box">
      <div class="" style="display: flex; align-items: center; justify-content: center">
        <div :class="current == index ? 'active' : ''" v-for="(item, index) in list" :key="index" style="
            width: 365px;
            height: 50px;
            background-color: #1c1a3c;
            color: #fff;
            text-align: center;
            line-height: 50px;
          " @click="current = index">
          {{ item }}
        </div>
      </div>
      <div class="" style="
          display: flex;
          justify-content: center;
          margin-top: 50px;
          text-decoration: underline;
        " v-if="current == 0">
        <a href="http://lingchuang.co">点击安卓APP安装包</a>
      </div>
      <div class="" style="text-align: center; margin: 30px">备用网址</div>
      <div class="" style="
          display: flex;
          justify-content: center;
          text-decoration: underline;
        " v-for="(item, index) in webblist" :key="index">
        <a :href="item">{{ item }}</a>
      </div>

    </div>
  </div>
</template>
<script>
import NavTop from "../components/NavTopWhit.vue";
import {
  getConfig

} from "../api/user.js";
export default {
  components: {
    NavTop,
  },
  data() {
    return {
      list: ["安卓APP", "苹果APP"],
      current: 0,
      webblist: []
    };
  },
  methods: {
    getBack() {
      getConfig().then((res) => {
        this.webblist = res.data.backup_domain
      });

    },
  },
  created() {
    this.getBack()

  }
};
</script>
<style scoped>
.content-box {
  width: 1200px;
  margin: 64px auto 30px;
  padding-top: 30px;
  padding-bottom: 50px;
  min-height: 400px;
}

.active {
  background-color: #4b72f6 !important;
}
</style>
